import { getPlayersByPlayerExternalIdAvailablePitchTypesOptions } from "@aura-frontend/omnibus-az-client";
import { useQuery } from "@tanstack/react-query";

import { GameType, PitcherHand, PlayerType } from "@/lib/types";

type useAvailablePitchTypesParams = {
  playerExternalId: string;
  startDate: string;
  endDate: string;
  gameType: GameType;
  playerType: PlayerType;
  vsHandedness: PitcherHand;
};

const vsHandednessMap: Record<PitcherHand, "left" | "right" | undefined> = {
  all: undefined,
  righty: "right",
  lefty: "left",
};

export const useAvailablePitchTypes = (
  params: useAvailablePitchTypesParams,
) => {
  const {
    playerExternalId,
    startDate,
    endDate,
    gameType,
    playerType,
    vsHandedness,
  } = params;

  const { data, isLoading, error } = useQuery({
    ...getPlayersByPlayerExternalIdAvailablePitchTypesOptions({
      path: {
        player_external_id: encodeURIComponent(playerExternalId),
      },
      query: {
        startDate: startDate,
        endDate: endDate,
        gameType: gameType === "practice" ? "bullpen" : "game",
        playerType: playerType,
        forChart: "heatmap",
        ...(vsHandedness !== "all" && {
          vsHandedness: vsHandednessMap[vsHandedness],
        }),
      },
    }),
    enabled: !!startDate && !!endDate && !!gameType && !!playerType,
    retry: false,
  });

  return {
    data: Array.isArray(data) ? data : [],
    isLoading,
    error,
  };
};
